import { render, staticRenderFns } from "./terms-of-agreements-short.vue?vue&type=template&id=a4ee227e&scoped=true&"
import script from "./terms-of-agreements-short.vue?vue&type=script&lang=js&"
export * from "./terms-of-agreements-short.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-agreements-short.vue?vue&type=style&index=0&id=a4ee227e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee227e",
  null
  
)

export default component.exports